import React from 'react'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const useStyles = makeStyles(() => ({
  btn: {
    borderRadius: '50%',
    padding: 0,
    minWidth: 'auto',
    width: '100%',
    margin: 0,
    '&:hover': { background: 'none' },
  },
  menuPaper: {
    background: '#006599',
    borderRadius: 0,
    padding: 0,
    boxShadow: 'none',
    left: '0 !important'
  },
}))

interface Props {
  content: (open: boolean) => React.ReactNode
  menuOffsetY?: number
}

const MenuToggleButton: React.FC<Props> = ({ content, children, menuOffsetY = 0 }) => {
  const wrapRef = React.useRef<HTMLDivElement | null>(null)
  const btnRef = React.useRef<HTMLButtonElement | null>(null)

  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null)
  const open = Boolean(anchor)

  const mobileScreen = useMediaQuery('(max-width:600px)')
  const classes = useStyles({ mobileScreen })

  return (
    <div ref={wrapRef} style={{ width: '100%' }}>
      <Button
        ref={btnRef}
        size="small"
        className={classes.btn}
        onClick={() => setAnchor(open ? null : btnRef.current)}
      >
        {content(open)}
      </Button>

      <Menu
        elevation={2}
        anchorEl={anchor}
        keepMounted
        open={open}
        onClose={() => setAnchor(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        MenuListProps={{ disablePadding: true, autoFocusItem: false }}
        PaperProps={{
          className: classes.menuPaper,
          style: {
            width: wrapRef.current?.offsetWidth,
            marginTop: -menuOffsetY,
          },
        }}
      >
        {children}
      </Menu>
    </div>
  )
}

export default MenuToggleButton